import { Component, OnInit } from '@angular/core';

import { FlowForecastLabelConstants } from './utils/constant/flow-forecast-gis-label.constant';
import { FlowForecastMapConstants } from './utils/constant/flow-forecast-gis.constant';
import { MapService } from './utils/service/map.service';

@Component({
  selector: 'app-flow-forecast',
  templateUrl: './flow-forecast.component.html',
  styleUrls: ['./flow-forecast.component.scss'],
})

export class FlowForecastComponent implements OnInit {

  otherOptions: {};

  constructor() { }

  ngOnInit() {
    this.getOtherOptions();
  }

  getOtherOptions() {
    const otherOptions = {};
    otherOptions['service'] = MapService;
    otherOptions['metaData'] = FlowForecastMapConstants;
    otherOptions['labelMetaData'] = FlowForecastLabelConstants;
    this.otherOptions = otherOptions;
  }
}
